import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import { setRangeValue } from "../../../../Utils/NumberUtils";
export var Wobble = /*#__PURE__*/function () {
  function Wobble() {
    _classCallCheck(this, Wobble);
    this.distance = 5;
    this.enable = false;
    this.speed = 50;
  }
  _createClass(Wobble, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }
      if (data.distance !== undefined) {
        this.distance = setRangeValue(data.distance);
      }
      if (data.enable !== undefined) {
        this.enable = data.enable;
      }
      if (data.speed !== undefined) {
        this.speed = setRangeValue(data.speed);
      }
    }
  }]);
  return Wobble;
}();